import { render, staticRenderFns } from "./ProductSkeletons.vue?vue&type=template&id=59f985e5&"
import script from "./ProductSkeletons.vue?vue&type=script&lang=js&"
export * from "./ProductSkeletons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports